import { useEffect } from 'react';
import './About.css';

const features = [
    { icon: 'fi fi-rs-shipping-fast', title: 'Free & Fast Shipping',   text: 'We ensure swift and timely delivery to your doorstep, so you can enjoy your decor without delay.' },
    { icon: 'fi fi-rs-badge-check',   title: 'Quality Products',        text: 'Every product is crafted with superior materials and attention to detail, guaranteeing durability and a premium finish.' },
    { icon: 'fi fi-rs-sparkles',      title: 'Amazing Designs',         text: 'Explore a unique collection of stylish, trendy, and elegant designs that uplift your living space.' },
    { icon: 'fi fi-rs-lock',          title: 'Safe Checkouts',          text: 'Shop with confidence with our fully secure and hassle-free online payment options.' },
];

const marketplaces = [
    { href: 'https://www.amazon.in/stores/PENTADECO/page/5CBF87B7-1BD3-4475-B3A1-1CF4DF594BAD?lp_asin=B0CR3P8MVX&ref_=ast_bln', img: '/assets/brand-amazon.webp',    alt: 'Amazon' },
    { href: 'https://www.nykaa.com/brands/pentadeco/c/58333',                                                                       img: '/assets/brand-nykaa.png',     alt: 'Nykaa' },
    { href: 'https://www.myntra.com/pentadeco?p=1',                                                                                  img: '/assets/brand-myntra.png',    alt: 'Myntra' },
    { href: 'https://www.meesho.com/MKENTERPRISETraditionalArts?ms=2',                                                             img: '/assets/brand-meesho.png',    alt: 'Meesho' },
];

const collageCount = 15;

const About = () => {
    useEffect(() => { window.scrollTo(0, 0); }, []);

    return (
        <div>

            {/* ── Hero ── */}
            <div className="about-hero">
                <div className="container">
                    <span className="about-hero-tag">Est. 2022</span>
                    <h1 className="about-hero-title">About Pentadeco</h1>
                    <p className="about-hero-sub">
                        Transforming everyday spaces with thoughtfully designed,<br className="d-none d-md-block" /> customizable décor products.
                    </p>
                </div>
            </div>

            {/* ── Brand Story ── */}
            <div className="about-story-section">
                <div className="container">
                    <div className="about-story-card">
                        <span className="about-section-label">Our Story</span>
                        <h2 className="about-story-title">Where Décor Meets Personality</h2>
                        <p className="about-story-text mb-3">
                            Pentadeco, incorporated in 2022, is a dynamic home decor &amp; kitchen and dining brand dedicated
                            to transforming everyday spaces with thoughtfully designed, customizable decor products. We believe
                            that your home should reflect your personality, which is why we specialize in delivering unique,
                            aesthetically appealing, and functional pieces that add a personal touch to your interiors.
                        </p>
                        <p className="about-story-text mb-0">
                            At Pentadeco, we focus on innovation, craftsmanship, and customer satisfaction. Each product is
                            designed with attention to detail, blending style with utility to cater to modern lifestyle needs.
                            Whether it's a striking wall accent, an elegant table piece, or an inspiring home organizer, our
                            designs are made to complement diverse tastes and living spaces.
                        </p>

                        {/* Stats */}
                        <div className="about-stats">
                            <div className="about-stat-item">
                                <span className="about-stat-num">2022</span>
                                <span className="about-stat-label">Founded</span>
                            </div>
                            <div className="about-stat-item">
                                <span className="about-stat-num">500+</span>
                                <span className="about-stat-label">Products</span>
                            </div>
                            <div className="about-stat-item">
                                <span className="about-stat-num">4</span>
                                <span className="about-stat-label">Marketplaces</span>
                            </div>
                            <div className="about-stat-item">
                                <span className="about-stat-num">50K+</span>
                                <span className="about-stat-label">Happy Customers</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* ── Marketplace ── */}
            <div className="about-marketplace">
                <div className="container">
                    <div className="text-center mb-4">
                        <span className="about-section-label">Where to find us</span>
                        <h2 className="about-section-title mb-1">Shop on Leading Marketplaces</h2>
                        <p className="about-section-sub mb-0">Find our products on all your favourite online platforms</p>
                    </div>
                    <div className="row g-3">
                        {marketplaces.map(({ href, img, alt }) => (
                            <div className="col-6 col-md-3" key={alt}>
                                <a href={href} target="_blank" rel="noreferrer" className="about-mkt-card">
                                    <img src={img} alt={alt} />
                                </a>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* ── Photo Collage ── */}
            <div className="about-collage-section">
                <div className="container">
                    <div className="text-center mb-4">
                        <span className="about-section-label">Our Products</span>
                        <h2 className="about-section-title mb-0">Crafted With Love</h2>
                    </div>
                    <div className="collage-wrap">
                        {Array.from({ length: collageCount }, (_, i) => (
                            <img key={i} src={`/assets/collage-${i + 1}.jpeg`} alt={`product ${i + 1}`} className="img-fluid" />
                        ))}
                    </div>
                </div>
            </div>

            {/* ── Features ── */}
            <div className="about-features">
                <div className="container">
                    <div className="text-center mb-4">
                        <span className="about-section-label">Why Choose Us</span>
                        <h2 className="about-section-title mb-0">The Pentadeco Promise</h2>
                    </div>
                    <div className="row g-3">
                        {features.map(({ icon, title, text }) => (
                            <div className="col-6 col-md-3" key={title}>
                                <div className="about-feat-card">
                                    <div className="about-feat-icon-wrap">
                                        <i className={icon}></i>
                                    </div>
                                    <p className="about-feat-title">{title}</p>
                                    <p className="about-feat-text">{text}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* ── Scrolling Banner ── */}
            <div className="about-banner-wrap">
                <div className="scrolling-container">
                    <img src="/assets/infinite-banner.jpg" alt="banner" className="scrolling-img" />
                    <img src="/assets/infinite-banner.jpg" alt="banner" className="scrolling-img" />
                </div>
            </div>

        </div>
    );
};

export default About;
